import { render, staticRenderFns } from "./ShipmentsManagement.vue?vue&type=template&id=2b46d05e&scoped=true&"
import script from "./ShipmentsManagement.vue?vue&type=script&lang=ts&"
export * from "./ShipmentsManagement.vue?vue&type=script&lang=ts&"
import style0 from "./ShipmentsManagement.vue?vue&type=style&index=0&id=2b46d05e&scoped=true&lang=css&"
import style1 from "./ShipmentsManagement.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b46d05e",
  null
  
)

export default component.exports